import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dbDateToHumanDateOnlyHour'
})
export class DbDateToHumanDateOnlyHourPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const aux = moment(value)
    return aux.format('HH:mm');
  }

}
